<template>
  <div class="box7">
   
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";

export default {
  components: {
    pageTitle,
    
  },
  data() {
    return {
     
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box7 {
  width: 100%;
  height: 776px;
  background: url("../../../assets/coursePage/design/box7/img01.png") no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
